import { useContext, useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux'
import EmbedReport from './EmbedReport';
import Placeholder from '../ui/Placeholder';
import { AppLoadContext } from "../ui/AppLoadContext";
import { getReportsToken } from "../../ducks/report";

const PowerBiReport = ({ title, reportName, filterState, reportRendered, printReport, setPrintReport }) => {
    const dispatch = useDispatch();

    const [reportConfig, setReportConfig] = useState(null);

    const isAppLoaded = useContext(AppLoadContext);
    const report = useSelector((state) => state.report);

    useEffect(() => {
        if (isAppLoaded) {
            dispatch(getReportsToken());
        }
    }, []);

    useEffect(() => {
        if (isAppLoaded && reportName && report[reportName]?.embedId) {
            setReportConfig({
                ...report[reportName],
                accessToken: report.accessToken,
            });
        }
    }, [report, reportName, isAppLoaded]);

    const handleError = (error) => {
        console.error("Power BI Embed Error: ", error);

        if(error?.message?.toLowerCase().includes("tokenexpired")) {
            dispatch(getReportsToken());
        }
    };

    return (
        <div className="embed-wrapper h-100">
            {reportConfig ? (
                <EmbedReport
                    filterState={filterState}
                    reportRendered={reportRendered}
                    setPrintReport={setPrintReport}
                    printReport={printReport}
                    handleError={handleError}
                    {...reportConfig}
                />
            ) : (
                <Placeholder
                    title={`Power BI - ${title}`}
                />
            )}
        </div>
    );
};

export default PowerBiReport;
